import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { CrudShellHeader } from "@/components/ds";

/**
 * Documentación de API para el tenant — vive bajo /app (ya protegido por el
 * beforeLoad de la ruta padre, mismo patrón que el resto de /app/*).
 *
 * Apunta a /api/v1/openapi, el spec curado que solo documenta los endpoints
 * habilitados para autenticarse con la API key del propio tenant (X-Api-Key).
 * /api/openapi (el spec completo, con rutas /api/admin/* de uso exclusivo del
 * SaaS interno de Structura) NUNCA debe mostrarse acá — ver ApiKeysPanel.tsx.
 */
export const Route = createFileRoute("/app/api-docs")({
  head: () => ({
    meta: [{ title: "Documentación de API — Structura Market" }],
    links: [
      { rel: "stylesheet", href: "https://unpkg.com/swagger-ui-dist@5.17.14/swagger-ui.css" },
    ],
  }),
  component: TenantApiDocsPage,
});

declare global {
  interface Window {
    SwaggerUIBundle: (opts: Record<string, unknown>) => void;
  }
}

function TenantApiDocsPage() {
  useEffect(() => {
    const existing = document.getElementById("swagger-ui-bundle-script");
    if (existing) {
      initSwagger();
      return;
    }
    const script = document.createElement("script");
    script.id = "swagger-ui-bundle-script";
    script.src = "https://unpkg.com/swagger-ui-dist@5.17.14/swagger-ui-bundle.js";
    script.onload = initSwagger;
    document.head.appendChild(script);
  }, []);

  function initSwagger() {
    if (typeof window.SwaggerUIBundle !== "function") return;
    window.SwaggerUIBundle({
      url: "/api/v1/openapi",
      dom_id: "#swagger-ui-root",
      presets: [
        (window as unknown as { SwaggerUIBundle: { presets: { apis: unknown } } })
          .SwaggerUIBundle.presets.apis,
      ],
      layout: "BaseLayout",
      deepLinking: true,
      tryItOutEnabled: true,
      persistAuthorization: true,
    });
  }

  return (
    <div className="flex h-screen flex-col">
      <CrudShellHeader
        title="Documentación de API"
        subtitle="Endpoints disponibles para integrar con tu API key (header X-Api-Key). Generá una desde Configuración → API."
      />
      {/* color-scheme: light fuerza estilos claros de Swagger UI sin importar el tema del panel. */}
      <div
        id="swagger-ui-root"
        className="flex-1 overflow-y-auto"
        style={{ colorScheme: "light", background: "#fff" }}
      />
    </div>
  );
}
